export default class Roles {

  constructor( api ) {
    this.api = api.child( 'role' )
  }

  /**
   * A Role object or an array of Role objects
   */
  create( role ) {
    return this.api.post( role )
  }

  list( opts ) {
    return this.api.get( opts )
  }

  delete( opts ) {
    return this.api.delete( opts )
  }
}
